import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';


@Injectable()
export class State {

  public immobles: any = {};
  private item : string = "favorits";
  constructor(public http: Http) {
    this.load();
  }

  public load(): void{
    let immobles = localStorage.getItem(this.item);
    this.immobles = immobles !== null ? JSON.parse(immobles) : this.setEmptyImmobles();
  }

  setEmptyImmobles () {
    this.saveImmobles([]);
    return [];
  }

  public setImmoble(id){
    if (this.comprovaImmobleExistent(id)) {
      this.immobles.push(id);
      this.saveImmobles(this.immobles);
    }
  }

  public deleteImmoble (id){
    this.immobles = this.immobles.filter((number)=>number != id);
    this.saveImmobles(this.immobles);
  }

  public saveImmobles (immobles) {
    localStorage.setItem(this.item, "[" + immobles + "]");
  }

  public comprovaImmobleExistent(id) {
    return this.immobles.indexOf(id) == -1;
  }

  public returnImmbobles(){
    return this.immobles;
  }

}



// WEBPACK FOOTER //
// ./src/providers/state.ts